// const api = "http://127.0.0.1:8000/api/";
const api = "https://techgate.ingeniosvirtuales.com/api/"
export default api;